{
  "name": "fieldwork-pwa",
  "version": "1.2",
  "description": "FieldWork PWA - Field data collection and crop validation",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --no-hmr",
    "start:dev": "ng serve --no-hmr --configuration development",
    "start:test": "ng serve --no-hmr --configuration test",
    "start:prod": "ng serve --configuration production",
    "build": "ng build",
    "build:dev": "ng build --configuration development",
    "build:test": "ng build --configuration test",
    "build:prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:ci": "ng test --no-watch --no-progress --coverage",
    "lint": "ng lint",
    "postbuild": "node script/rename-files.js",
    "generate-proxy-win": "cd nswag && generate-proxy.bat",
    "generate-proxy-win:dev": "cd nswag && generate-proxy.bat development",
    "generate-proxy-win:test": "cd nswag && generate-proxy.bat test",
    "generate-proxy-win:prod": "cd nswag && generate-proxy.bat production",
    "generate-proxy-macos": "cd nswag && sh generate-proxy.sh",
    "generate-proxy-macos:dev": "cd nswag && sh generate-proxy.sh development",
    "generate-proxy-macos:test": "cd nswag && sh generate-proxy.sh test",
    "generate-proxy-macos:prod": "cd nswag && sh generate-proxy.sh production",
    "generate-proxy": "cd nswag && sh generate-proxy.sh",
    "generate-proxy:dev": "cd nswag && sh generate-proxy.sh development",
    "generate-proxy:test": "cd nswag && sh generate-proxy.sh test",
    "generate-proxy:prod": "cd nswag && sh generate-proxy.sh production",
    "shake-proxies": "node script/shake-proxies.mjs",
    "shake-proxies:dry": "node script/shake-proxies.mjs --dry-run",
    "kill-port": "npx kill-port 4200"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "^21.2.24",
    "@angular/compiler": "^21.2.24",
    "@angular/core": "^21.2.24",
    "@angular/forms": "^21.2.24",
    "@angular/platform-browser": "^21.2.24",
    "@angular/router": "^21.2.24",
    "@angular/service-worker": "^21.2.24",
    "@mapbox/mapbox-gl-draw": "^1.5.1",
    "@mapbox/mapbox-gl-draw-static-mode": "^1.0.1",
    "@ngx-translate/core": "^18.0.0",
    "@phosphor-icons/web": "^2.1.2",
    "@primeuix/themes": "^2.0.3",
    "@turf/turf": "^7.2.0",
    "bootstrap": "^5.3.6",
    "luxon": "^3.6.1",
    "mapbox-gl": "^3.16.0",
    "primeicons": "^7.0.0",
    "primeng": "^21.1.10",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.2.24",
    "@angular/cli": "^21.2.24",
    "@angular/compiler-cli": "^21.2.24",
    "@types/luxon": "^3.4.2",
    "@types/mapbox__mapbox-gl-draw": "^1.4.9",
    "@types/mapbox-gl": "^3.4.1",
    "@vitest/coverage-v8": "^4.1.11",
    "angular-eslint": "21.4.0",
    "eslint": "^9.35.0",
    "eslint-config-prettier": "^10.1.8",
    "jsdom": "^28.1.0",
    "less": "^4.2.0",
    "nswag": "^14.3.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "8.40.0",
    "vitest": "^4.1.11"
  }
}
